export enum SidebarEnum {
  FILLED = 'Filled',
  NOT_FILLED = 'Empty',
}
export interface SidebarSection {
  title: string;
  path: string;
  statusProp?: string;
  displayMemberName?: string;
  status?: SidebarEnum;
  children?: SidebarSection[];
  hidden?: boolean;
  id?: string;
}

export interface SidebarProps {
  sectionData: SidebarSection[];
  mode?: string;
  hideBackIcon?: boolean;
  hideStatus?: boolean;
  permissionCheck?: boolean;
}
export interface SectionListProps {
  items: SidebarSection[];
  mode?: string;
  hideStatus?: boolean;
  permissionCheck?: boolean;
}
export interface AdminSection {
  project: SidebarSection[];
  security: SidebarSection[];
  settings: SidebarSection[];
}
export interface CommoditySection {
  cable: SidebarSection[];
  raceway: SidebarSection[];
  equipment: SidebarSection[];
  jumper: SidebarSection[];
  'cable-code': SidebarSection[];
  'cable-reels': SidebarSection[];
  equipmentcode: SidebarSection[];
  colorCode: SidebarSection[];
  fireArea: SidebarSection[];
  'raceway-codes': SidebarSection[];
  package: SidebarSection[];
}
